import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["required"];

  validate = this._validate.bind(this);

  connect() {
    this.element.addEventListener('checkout--cash:validate-form', this.validate.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('checkout--cash:validate-form', this.validate.bind(this));
  }

  _validate(event) {
    let isValid = true;

    this.requiredTargets.forEach((target) => {
      if (target.value === "") {
        target.setCustomValidity("This field is required");
        isValid = false;
      } else if (target.type === "email" && !this.isValidEmail(target.value)) {
        target.setCustomValidity("Please enter a valid email address");
        isValid = false;
      } else {
        target.setCustomValidity("");
      }
      target.reportValidity();
    });

    if (!isValid) {
      event.preventDefault();
    }
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}